var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5403 13.7847L11.6882 10.0644L13.8361 6.34409C14.627 4.97432 14.1577 3.22279 12.7879 2.43195V2.43195C11.4181 1.6411 9.66657 2.11042 8.87573 3.4802L6.72781 7.20051",
    stroke: "white",
    strokeWidth: 0.937092
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92403 7.39246L8.31309 10.1827L6.34417 13.593C5.94875 14.2779 6.18341 15.1536 6.8683 15.549V15.549C7.55319 15.9445 8.42895 15.7098 8.82437 15.0249L10.7933 11.6146",
    stroke: "white",
    strokeWidth: 0.937092,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15979 4.72039L4.57993 10.9209L3.12183 13.4464C1.95001 15.476 2.64542 18.0713 4.67507 19.2432L4.76567 19.2955C6.79532 20.4673 9.39062 19.7719 10.5624 17.7422L14.8844 10.2563",
    stroke: "white",
    strokeWidth: 0.937092,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteAttachIcon);
export default __webpack_public_path__ + "static/media/white-attach-icon.fd45361c8ea30ac21cfbb211289f7d3b.svg";
export { ForwardRef as ReactComponent };